import BrowserService, { EXTENSIONS_IDS } from '@/utils/BrowserService';

const sendToExtension = (payload) =>
	new Promise((resolve) => {
		const sent = BrowserService.sendToExtension(payload, (r) => {
			resolve(r);
		});
		if (!sent) {
			resolve();
		}
	});

const sendToExtensions = (payload, callback) => BrowserService.sendToExtensions(payload, callback);

const sendToSpecificExtension = (extId, payload) =>
	new Promise((resolve) => {
		const sent = BrowserService.sendToSpecificExtension(extId, payload, (r) => {
			resolve(r);
		});
		if (!sent) {
			resolve();
		}
	});

const trySendAllExtensionsAndGetFirstResponse = async (payload) => {
	const responses = await Promise.allSettled(EXTENSIONS_IDS.map((extId) => sendToSpecificExtension(extId, payload)));
	return responses.find((response) => !!response.value)?.value;
};

export default {
	hasAccessForDomain(domain) {
		return sendToExtension({ action: 'hasAccessForDomain', value: { origin: domain } });
	},

	askAccessForDomain(domain) {
		return sendToExtension({ action: 'askAccessForDomain', value: { origin: domain } });
	},

	getVersion() {
		return trySendAllExtensionsAndGetFirstResponse({ action: 'version' });
		/**
		 * AFTER WE HAVE ONLY ONE EXT, UNCOMMENT THIS
		return sendToExtension({ action: 'version' });
		 */
	},

	hasAccessForAllUrls() {
		return sendToExtension({ action: 'hasAccessForAllUrls' });
	},
	getCommandBarShortcut() {
		return sendToExtension({ action: 'getCommandBarShortcut' });
	},
	askAccessForAllUrls() {
		return sendToExtension({ action: 'askAccessForAllUrls' });
	},

	reportPinnedExtension() {
		// todo - change this to sendToExtension after mv3 is live (uncomment)
		return sendToExtensions({ action: 'pinnedExtension' });
		// return sendToExtension({ action: 'pinnedExtension' });
	},

	startCreationProcess(payload) {
		// todo - change this to sendToExtension after mv3 is live (uncomment)
		return sendToExtensions({ action: 'startCreationProcess', value: payload }); // this will return undefined
		// return sendToExtension({ action: 'startCreationProcess', value: payload });
	},

	startChangeSampleProcess(payload) {
		// todo - change this to sendToExtension after mv3 is live (uncomment)
		return sendToExtensions({ action: 'startChangeSampleProcess', value: payload }); // this will return undefined
		// return sendToExtension({ action: 'startChangeSampleProcess', value: payload });
	},
	notifyExtensionPageCreated() {
		// todo - change this to sendToExtension after mv3 is live (uncomment)
		return sendToExtensions({ action: 'builderScreenLoaded' });
		// return sendToExtension({ action: 'notifyExtensionPageCreated', value: payload });
	},
	announceWorkflow(workflow) {
		return sendToExtensions({ action: 'workflowPublished', value: { workflow } });
	},
	announceWorkflows(workflowIds) {
		return sendToExtensions({ action: 'retrieveWorkflows', value: { workflows: workflowIds } });
	},
	announceButtonDropdown(buttonDropdown) {
		return sendToExtensions({ action: 'retrieveButtonDropdown', value: { buttonDropdown } });
	},
};
